import { BaseUseCase } from "@domains/useCases/UseCaseBase";
export default class DownloadExcelReport extends BaseUseCase {
    constructor(downloadRepo) {
        super();
        this.downloadRepo = downloadRepo;
    }
    fetchResult(data) {
        return this.downloadRepo.donwloadExel(data);
    }
}
